import React from 'react';
import ReactDOM from 'react-dom/client';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import '@sequelae/lore-core/dist/styles/index.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { launchDarklyConfig } from './config/launchDarklyConfig';

// Polyfill for web: when MFEs send bridge navigation (e.g. LoreBot, Rewards), there is
// no native WebView. Expose a fake webkit handler so bridge messages forward here and
// we can handle rewards/streaks (and other) navigation in the shell (see App.tsx).
(function polyfillWebBridge() {
  if (typeof window === 'undefined') return;
  const w = window as Window & { webkit?: { messageHandlers?: { nativeHandler?: { postMessage: (msg: { type: string; payload?: Record<string, unknown> }) => void } } } };
  if (w.webkit?.messageHandlers?.nativeHandler) return; // already native
  w.webkit = w.webkit || {};
  w.webkit.messageHandlers = w.webkit.messageHandlers || {};
  w.webkit.messageHandlers.nativeHandler = {
    postMessage: (msg: { type: string; payload?: Record<string, unknown> }) => {
      window.dispatchEvent(
        new CustomEvent('LORE_BRIDGE_NAVIGATION', { detail: { messageType: msg.type, payload: msg.payload || {} } })
      );
    },
  };
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const AppWithStrictCheck = () => (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (launchDarklyConfig.clientSideID) {
  const LDProvider = withLDProvider({
    clientSideID: launchDarklyConfig.clientSideID,
    options: launchDarklyConfig.options,
    context: { kind: 'user', key: 'anonymous', anonymous: true },
  })(AppWithStrictCheck);
  root.render(<LDProvider />);
} else {
  root.render(<AppWithStrictCheck />);
}

reportWebVitals();

// Intercept lore:// deeplinks (e.g. Rewards "Let's Go!" → verification) and redirect to web app routes
function getWebRouteForLoreUrl(href: string): string | null {
  const u = (href || '').toLowerCase().replace(/^lore:\/\//, '').replace(/^\//, '');
  if (u.includes('verification')) return '/account/verification';
  if (u.includes('privacy')) return '/privacy';
  if (u === 'account' || u === 'menu') return '/account';
  if (u.includes('rewards')) return '/rewards';
  if (u.includes('community')) return '/community';
  if (u.includes('lorebot')) return '/lorebot';
  if (u === 'more' || u.startsWith('more/')) return '/more';
  if (u.includes('notifications')) return '/account/notifications';
  if (u.includes('invitations')) return '/account/invitations';
  if (u.includes('help') || u.includes('faq')) return '/account/help';
  return null;
}

document.addEventListener('click', (e) => {
  const link = (e.target as HTMLElement).closest?.('a[href]');
  if (!link) return;
  const href = (link.getAttribute('href') || '').trim();
  if (href.startsWith('lore://')) {
    const route = getWebRouteForLoreUrl(href);
    if (route) {
      e.preventDefault();
      window.location.href = route;
    }
  }
}, true);

// LoreBot "Update Privacy Settings" → /privacy
setTimeout(() => {
  document.addEventListener('click', (e) => {
    const el = (e.target as HTMLElement).closest?.('button');
    if (!el) return;
    const t = (el.textContent || '').trim();
    if (t === 'Update Privacy Settings' || (t.includes('Update Privacy Settings') && !t.includes('Refresh') && !t.includes('Expand'))) {
      e.preventDefault();
      window.location.href = '/privacy';
    }
  }, true);
}, 1000);
